export default __webpack_public_path__ + "a21aaff67e91d55c43b162065285398c.svg";